import { PAID, PAY } from 'containers/Invoice/constant';
import React, { useEffect, useState } from 'react';
import './InvoicePaymentStatusChange.scss';
import PropTypes from 'prop-types';

import {
    Accordion,
    Alert,
    ConditionalComponent,
    DatePicker,
    FormElems,
} from 'components';

import FakeLoader from '../../components/FakeLoader';

import { isPresentOrDefault } from 'utils/helperMethods';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { compose } from 'redux';
import moment from 'moment';
import {
    updateInvoicePaymentStatusRequest,
    updateInvoicePaymentStatusReset,
} from 'containers/Invoice/redux/invoice.actions';

const InvoicePaymentStatusChange = ({
    data,
    actions,
    handleSubmit,
    formData,
    invoiceData,
    onUpdateStatusSuccess,
}) => {
    const merchantId = isPresentOrDefault(data?.merchantId, '-');
    const merchantName = isPresentOrDefault(data?.merchantName, '-');
    const invoicePeriod = isPresentOrDefault(data?.invoicePeriod, '-');
    const paymentStatus = isPresentOrDefault(data?.paymentStatus, '-');
    const invoiceDate = isPresentOrDefault(data?.invoiceDate, '-');
    const invoiceNumber = isPresentOrDefault(data?.invoiceNumber, '-');
    const settlementType = isPresentOrDefault(data?.settlementType, '-');
    const grossAmount = isPresentOrDefault(data?.grossAmount, '-');
    const totalFee = isPresentOrDefault(data?.totalFee, '-');
    const totalGst = isPresentOrDefault(data?.totalGst, '-');
    const totalValue = isPresentOrDefault(data?.totalValue, '-');

    const {
        isSuccessfulRefund,
        isStatusLoading,
        statusUpdateError,
    } = invoiceData;

    const buttonTitle = paymentStatus === PAID ? PAID : PAY;

    useEffect(() => {
        if (isSuccessfulRefund) {
            onUpdateStatusSuccess();
            actions.updateInvoicePaymentStatusReset();
        }
    }, [isSuccessfulRefund]);

    const [invoicePaymentDate, setInvoicePaymentDate] = useState(
        moment().endOf('day')
    );

    const [focusedInput, setFocusedInput] = useState(null);

    const handleFormSubmit = values => {
        const data = {
            invoiceNumber,
            paymentStatus: PAID,
            utr: values.utr,
        };

        if (invoicePaymentDate) {
            data.invoicePaymentDate = moment(invoicePaymentDate)
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
        }

        const payload = { ...data };
        actions.updateInvoicePaymentStatusRequest(payload);
    };

    return (
        <div className="settlemnt-invoice-data">
            <div className="invoice-data-wrap-multiple">
                <span className="invoice-data">
                    <p className="label">Merchant ID</p>
                    <p className="data">{merchantId}</p>
                </span>
                <span className="invoice-data">
                    <p className="label">Merchant Name</p>
                    <p className="data">{merchantName}</p>
                </span>
            </div>
            <div className="invoice-data-wrap-multiple">
                <span className="invoice-data">
                    <p className="label">Invoice Period</p>
                    <p className="data">{invoicePeriod}</p>
                </span>
                <span className="invoice-data">
                    <p className="label">Payment Status</p>
                    <p className="data">{paymentStatus}</p>
                </span>
            </div>
            <div className="invoice-data-wrap-multiple">
                <span className="invoice-data">
                    <p className="label">Invoice Date</p>
                    <p className="data">{invoiceDate}</p>
                </span>
                <span className="invoice-data">
                    <p className="label">Invoice number</p>
                    <p className="data">{invoiceNumber}</p>
                </span>
            </div>
            <div className="invoice-data-wrap-multiple">
                <span className="invoice-data">
                    <p className="label">Settlement Type</p>
                    <p className="data">{settlementType}</p>
                </span>
            </div>
            <div className="invoice-data-wrap-multiple">
                <span className="invoice-data">
                    <p className="label">Gross Amount</p>
                    <p className="data">{grossAmount}</p>
                </span>
                <span className="invoice-data">
                    <p className="label">Total Fee</p>
                    <p className="data">{totalFee}</p>
                </span>
            </div>
            <div className="invoice-data-wrap-multiple">
                <span className="invoice-data">
                    <p className="label">Total GST</p>
                    <p className="data">{totalGst}</p>
                </span>
                <span className="invoice-data">
                    <p className="label">Total Value</p>
                    <p className="data">{totalValue}</p>
                </span>
            </div>
            <ConditionalComponent
                isVisible={
                    paymentStatus === 'UNPAID' &&
                    settlementType?.toUpperCase() === 'GROSS'
                }
            >
                <Accordion
                    customClass="rounded-accordion"
                    isOpened={true}
                    isArrowIndicator
                    id="live-invoice-data-accordion"
                    upperComponent={
                        <>
                            <h3 className="page-tile sm">
                                <span className="heading">
                                    Update Invoice Status
                                </span>
                            </h3>
                        </>
                    }
                    lowerComponent={
                        <>
                            {isStatusLoading ? <FakeLoader withMask /> : <></>}
                            <form
                                className="invoice-status-change-form"
                                onSubmit={handleSubmit(handleFormSubmit)}
                            >
                                <div className="form-section">
                                    <div className="form-field">
                                        <p className="label">
                                            Invoice Payment Date
                                        </p>
                                        <Field
                                            name="invoicePaymentDate"
                                            component={DatePicker}
                                            singleDatePicker
                                            startDateId="invoicePaymentDate"
                                            onFocusedInput={setFocusedInput}
                                            onSetStartDate={
                                                setInvoicePaymentDate
                                            }
                                            startDate={invoicePaymentDate}
                                            focusedInput={focusedInput}
                                            isOutsideRange={day => {
                                                return (
                                                    moment().diff(
                                                        day.endOf('day'),
                                                        'days'
                                                    ) < 0
                                                );
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="form-section">
                                    <div className="form-field">
                                        <p className="label">UTR</p>
                                        <Field
                                            name="utr"
                                            type="text"
                                            component={FormElems.Input}
                                            placeholder="Enter UTR"
                                        />
                                    </div>
                                </div>

                                {statusUpdateError &&
                                statusUpdateError.errorMessage ? (
                                    <Alert customClass="error-msg">
                                        {statusUpdateError.errorMessage}
                                    </Alert>
                                ) : null}
                                <div className="action">
                                    <button type="primary" className="edit-btn">
                                        {buttonTitle}
                                    </button>
                                </div>
                            </form>
                        </>
                    }
                />
            </ConditionalComponent>
        </div>
    );
};

InvoicePaymentStatusChange.propTypes = {
    data: PropTypes.object,
    actions: PropTypes.object,
    formData: PropTypes.object,
    handleSubmit: PropTypes.func,
    onUpdateStatusSuccess: PropTypes.func,
};

const mapStateToProps = ({ auth, form, invoiceData }) => ({
    auth,
    formData: form['invoice-status-change-form'],
    invoiceData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            updateInvoicePaymentStatusRequest,
            updateInvoicePaymentStatusReset,
        },
        dispatch
    ),
});

export default compose(
    reduxForm({
        form: 'invoice-status-change-form',
        validate: () => {},
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(InvoicePaymentStatusChange);
